<template>
  <div class="pos-device" ref="cd">
    <b-container class>
      <b-row class="pos-row">
        <!-- <div  class="waypoint"
        v-waypoint="{ active: true, callback: scrollToCd, options: intersectionOptions }"></div>-->
        <b-col id="pos-left" lg="6" sm="12">
         <!-- <Headings class="titleX" data="ftcash PoS K300" /> -->

          <b-row class="info">
            <b-col md="10" sm="12">
              <p>Swipe all types of cards and pay your EDIs - The new PoS terminal is all you need to make your business digital.</p>
            </b-col>
          </b-row>
          <b-row class="calculation">
            <b-col sm="12" lg="8" class="calculation-column">
              <b-row class="calculation-row">
                <b-col lg="3" md="2" sm="2" class="base-amt">
                  <p>&#8377;7,500 </p>
                  <p class="device-text">(Device)</p>
                </b-col>
                <b-col lg="9" md="10" sm="10" class="total-amt">
                  <p> + GST = &#8377;8,850</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <!-- <b-row class="device">
            <b-col sm="12">
            </b-col>
          </b-row>-->
          <!-- <b-row class="applynow">
            <b-col sm="12">
              <button
                type="button"
                class="applying-btn btn btn-danger"
                @click="applyLink()"
              >Apply Now</button>
            </b-col>
          </b-row> -->
        </b-col>
        <b-col id="pos-right" lg="6" sm="12">
          <img class="device-img" alt="POS Device K300" :src="require(`@/assets/img/pos-device.jpg`)" />
        </b-col>
        <!-- <div  class="waypoint"
        v-waypoint="{ active: true, callback: scrollToPd, options: intersectionOptions }"></div>-->
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "PosDevice",
  data() {
    return {
     
    };
  },
  methods: {
    applyLink() {
      // window.location.href = ("https://www.ftcash.com/app/loan/index", '_blank');
      window.open("https://www.ftcash.com/app/loan/index", "_blank");
    },
    
  },
};
</script>
<style scoped>
.device {
  color: var(--mainBlueColor);
  text-align: left;
  font-size: 1.05rem;
  margin-bottom: 3rem;
}
.device-img {
  width: 80%;
  height: 88%;
}
.info {
  font-size: 1rem;
  color: var(--mainBlueColor);
  text-align: left;
  margin-top: 2rem;
}
.calculation {
  color: var(--mainBlueColor);
  font-size: 1.5rem;
  text-align: left;
  margin: 2rem 0;
  font-size: 1.25rem;
}
.applynow {
  height: 100%;
  text-align: left;
}
.pos-row {
  height: 100%;
  /*padding: 3rem, 0;*/
}
.btn-danger {
  background-color: var(--mainRedColor);
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
}

.btn-danger:hover {
    color: #fff;
    background-color: #c82333;
    border-color: #bd2130;
    box-shadow: 0px 0px 2px rgba(208, 208, 208, 0.4);
}
p {
  margin-bottom: 0;
}
.calculation-column {
  padding-left: 0;
}

.device-text {
  font-size: 0.9rem;
}
.total-amt {
  padding-left: 0;
}
.base-amt {
  padding-right: 0;
}

/* Media Queries */
/* Tablet View */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
 
  .calculation {
    color: var(--mainBlueColor);
    font-size: 1.5rem;
    transform: translateX(29%);
  }
  .info {
    color: var(--mainBlueColor);
    text-align: center;
    justify-content: center;
    width: 80%;
    margin: auto;
  }
  .applynow {
    text-align: center;
    margin: 2rem auto;
    height: auto;
  }
  .applying-btn {
    font-size: 1.125rem;
  }
  .device-img {
    width: 58%;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .calculation {
    color: var(--mainBlueColor);
    font-size: 1.4rem;
    transform: translateX(20%);
  }
  .info {
    color: var(--mainBlueColor);
    text-align: center;
    justify-content: center;
    margin: 2rem 0;
  }
  .applynow {
    text-align: center;
    margin: 2rem auto;
    height: auto;
  }
  .applying-btn {
    font-size: 1.125rem;
  }
  .total-amt {
    padding-left: 15px;
  }
  #pos-left,
  #pos-right {
    margin: auto 0;
  }
}
/* Mobile View */
@media (min-width: 481px) and (max-width: 767px) {
  .title {
    text-align: center;
  }
  .calculation {
    color: var(--mainBlueColor);
    font-size: 1.4rem;
    transform: translateX(20%);
  }
  .info {
    text-align: center;
    order: 2;
  }
  .applynow {
    text-align: center;
    margin: 2rem auto;
    height: auto;
  }
  .device-img {
    order: 1;
  }
  .applying-btn {
    font-size: 1.125rem;
  }
  .total-amt {
    padding-left: 6px;
  }
}
@media (max-width: 480px) {
  .title {
    text-align: center;
  }
  .calculation {
    color: var(--mainBlueColor);
    font-size: 1.125rem;
    justify-content: center;
    text-align: center;
    margin: 2rem auto;
    /* transform: translateX(20%); */
  }
  .device {
    color: var(--mainBlueColor);
    font-size: 0.9rem;
    text-align: center;
    justify-content: center;
    margin-bottom: 1rem;
  }
  .info {
    font-size: 0.9rem;
    color: var(--mainBlueColor);
    text-align: center;
    justify-content: center;
    order: 2;
  }
  .applynow {
    height: 100%;
    text-align: center;
    margin-top: 0;
    margin-bottom: 2rem;
  }
  .device-img {
    order: 1;
  }
  /*.pos-device {
    padding: 1.25rem 0;
  }*/
  .pos-row {
    padding: 1rem, 0;
  }
  .applying-btn {
    font-size: 0.8rem;
  }
  .base-amt {
    width: 19%;
  }
  .total-amt {
    width: 50%;
  }
  .calculation-row {
    justify-content: center;
  }
}
</style>
